<template>
    <div class="header-counryList mr-2">
        <!-- Toggle button -->
        <a href="#" class="f-14 d-flex justify-content-center align-items-center" @click.stop.prevent="countryList = !countryList">
            <img :src="selectedFlag" alt="" />
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12px"
                height="12px"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-chevron-down feather__content"
            >
                <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
        </a>

        <!-- Dropdown -->
        <div class="countryList-box" :class="{ 'd-block': countryList, 'd-none': !countryList }">
            <ul class="scrollbar">
                <li v-for="(lang, index) in languages" :key="index" class="d-flex" @click="selectLanguage(lang)">
                    <img :src="lang.flag" alt="" />
                    <span>{{ lang.name }}</span>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
    import i18n from '@/plugins/lang/i18n';
    export default {
        name: "CountryList",
        props: {
            defaultLang: {
                type: String,
                default: "English",
            },
        },
        data() {
            return {
                countryList: false,
                selectedLang: this.defaultLang,
                languages: [
                    { name: "English", flag: "../../../../static/website/images/country_images/united kingdom.svg", locale: "en", flagico: "flag-eng" },
                    { name: "Spanish", flag: "../../../../static/website/images/country_images/spain.svg", locale: "es", flagico: "flag-spa" },
                    { name: "Estonian", flag: "../../../../static/website/images/country_images/estonia.svg", locale: "et", flagico: "flag-est" },
                    { name: "Greek", flag: "../../../../static/website/images/country_images/greece.svg", locale: "el", flagico: "flag-gr" },
                    { name: "Arabic", flag: "../../../../static/website/images/country_images/united arab emirates.svg", locale: "ar", flagico: "flag-arb" },
                    { name: "Indonesian", flag: "../../../../static/website/images/country_images/Indonesia.svg", locale: "id", flagico: "flag-id" },
                ],
            };
        },
        computed: {
            selectedFlag() {
                const lang = this.languages.find((l) => l.name === this.selectedLang);
                return lang ? lang.flag : "";
            },
        },
        created() {
            // load from localStorage
            const storedLang = localStorage.getItem("lang") || this.defaultLang;
            const langConfig = this.languages.find((l) => l.name === storedLang);

            if (langConfig) {
                this.applyLanguage(langConfig);
            } else {
                this.applyLanguage(this.languages[0]); // fallback English
            }
        },
        methods: {
            toggleList() {
                this.countryList = !this.countryList;
            },
            selectLanguage(lang) {
                this.applyLanguage(lang);
                this.countryList = false;
            },
            applyLanguage(lang) {
                this.selectedLang = lang.name;
                this.flagico = lang.flagico;
                localStorage.setItem("lang", lang.name);

                i18n.locale = lang.locale;
                this.$root.$children[0].languageChangeDetect = lang.locale;

                // call API
                // const input_json = {
                //     globalParams: { lang: this.selectedLang },
                //     localParams: { parameter: this, page: this.page },
                // };
                // this._runLanguageApi && this._runLanguageApi(input_json);

                this.$emit("language-selected", lang); // emit full object
            },
        },
    };
</script>
<style scoped>
    .countryList-box {
        position: absolute;
        background: #fff;
        border: 1px solid #ddd;
        z-index: 1000;
    }
    .scrollbar {
        max-height: 200px;
        overflow-y: auto;
    }
</style>



// WEBPACK FOOTER //
// src/components/website/shared/language.vue